import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Injector,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IInputComponent } from '@nimbus-library/features/shared/components/material/i-input-component';
import { InputSearchStorageKeys } from '@nimbus-library/features/shared/components/material/input-search/input-search-storage-keys.enum';
import { InputSearchStorageKeysService } from '@nimbus-library/features/shared/components/material/input-search/input-search-storage-keys.service';

@Component({
  standalone: false,
  selector: 'nimbus-input-search',
  templateUrl: './input-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputSearchComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => InputSearchComponent),
    },
  ],
})
export class InputSearchComponent extends IInputComponent implements OnInit {
  @ViewChild('inputElement', { static: true })
  public inputElement: ElementRef<HTMLInputElement>;

  @Input()
  public noPermissions: boolean = false;
  @Input()
  public suffixTemplateRef: TemplateRef<any>;
  @Input()
  public prefixTemplateRef: TemplateRef<any>;
  @Input()
  public storageKey: InputSearchStorageKeys | undefined;

  private localStorageKey: string | null;

  public set value(value: string) {
    super.value = value;
    if (this.localStorageKey) {
      localStorage.setItem(this.localStorageKey, value || '');
    }
  }

  public get value(): string {
    return super.value;
  }

  public constructor(
    changeDetectionRef: ChangeDetectorRef,
    injector: Injector,
    translateService: TranslateService,
    private readonly storageKeysService: InputSearchStorageKeysService,
  ) {
    super(changeDetectionRef, injector, translateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.localStorageKey = this.storageKeysService.getLocalStorageKey(this.storageKey);
    this.restoreValueFromLocalStorage();
  }

  public onKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Escape') {
      event.stopPropagation();
    }
  }

  public focus(): void {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  public validate(control: AbstractControl): ValidationErrors {
    if (!control || !control.value) {
      return null;
    }
    const value = control.value;

    return null;
  }

  private restoreValueFromLocalStorage(): void {
    const storedValue = !!this.localStorageKey && localStorage.getItem(this.localStorageKey);
    if (!storedValue) {
      return;
    }

    setTimeout(() => {
      this.value = storedValue;
      this.markForCheck();
    });
  }
}
